<template>
  <div>
    <div class="fight">
      <div class="slide">
        <mySlide />
      </div>
      <div class="fight-warp w1500">
        <div>
          <div class="fight-search">
            <div class="fight-search-top">
              <div class="btn-w-r-bg" style="margin: 0;" @click="$router.push('/fight/add')">
                <div class="btn-c-r">
                  创建对战
                </div>
              </div>
              <div class="scRadio">
                <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='two'}" @click="handleClick('two')">双人模式</div>
                <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='three'}" @click="handleClick('three')">三人模式</div>
                <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='history'}" @click="handleClick('history')">历史记录</div>
                <div class="scRadio-item" :class="{'scRadio-item-a':activeName=='me'}" @click="handleClick('me')">我的房间</div>
              </div>
            </div>
            <div v-show="activeName=='me'" class="fight-search-form flex flex-ac">
              <div class="s-item flex flex-ac" :class="{'s-item-active':searchForm.type==1}" @click="handleCommand(1)">
                <i class="iconfont" :class="[searchForm.type==1?'icon-a-Checkbox':'icon-duoxuan_weixuanzhong']"></i>
                <span>自建房</span>
              </div>
              <div class="s-item flex flex-ac" :class="{'s-item-active':searchForm.type==2}" @click="handleCommand(2)">
                <i class="iconfont" :class="[searchForm.type==2?'icon-a-Checkbox':'icon-duoxuan_weixuanzhong']"></i>
                <span>挑战房</span>
              </div>
            </div>
            <!-- <el-select v-model="searchForm.mode" class="sel-form-select" placeholder="请选择" @change="handleCommand">
              <el-option label="全部" value=""></el-option>
              <el-option label="双人模式" :value="2"></el-option>
              <el-option label="三人模式" :value="3"></el-option>
            </el-select> -->
          </div>
          <div class="room-box">
            <ul class="room-box-ul">
              <!-- 1等待 2 中 3 结束 -->
              <li v-for="item in list" :key="item.id" :class="{'bg_1':item.status==1,'bg_2':item.status==2,'bg_3':item.status==3}" @click="goLuckyRoom(item,item.id)">
                <div class="roombox-warp">
                  <div class="one flex flex-jsb flex-ac">
                    <span class="span1">
                      <span class="span-dian"></span>{{ item.status==1?'等待中':item.status==2?'进行中':'已结束' }}</span>
                    <img src="@/assets/img/fight/dzwj.png" alt="" srcset="" class="status-img">
                    <span class="span3">{{ item.boxInfo.length }}回合</span>
                  </div>
                  <div class="no">房间号：{{ item.room_num }}</div>
                  <div class="two flex flex-jc">
                    <div class="room-peo flex flex-ac">
                      <div v-for="(player,pi) in item.player_info" :key="pi" class="pk-warp flex flex-ac">
                        <img :src="player.img" alt="" srcset="" class="pk-true" :class="{'pk-false':player.id==0}">
                        <img v-if="pi!=(item.player_info.length-1)" src="@/assets/img/fight/vs.png" alt="" srcset="" class="pk-vs">
                      </div>
                    </div>
                  </div>
                  <div class="card-footer flex flex-jsb flex-ac">
                    <div class="three flex flex-ac flex-1">
                      <div v-for="(box,bi) in item.fightboxList" :key="bi" class="box-detail">
                        <img :src="box.img_main" />
                        <div class="box-num">{{ bi+1 }}</div>
                      </div>
                    </div>
                    <div class="two-top flex flex-ac">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.box_price?item.box_price.toFixed(2):item.total_price }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="clear"></div>
            <!-- <div v-if="searchForm.page<searchForm.pages" @click="moveList()" class="btn-w-r-bg">
              <div class="btn-c-r">
                查看更多
              </div>
            </div> -->
          </div>
          <div v-if="list.length>0" class="csgo-page">
            <el-pagination background :pager-count="5" layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
        <div v-if="list.length===0" class="no-data">
          <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
          <div class="text">暂无任何数据哦~</div>
        </div>
      </div>
      <div class="about">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">关于逐鹿之战</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="w1500">
          <div class="info">
            <div style="overflow: hidden;" :class="{'height40':!showMore}">
              <div v-html="boxInfo.content" class="html-box"></div>
            </div>
            <div class="show-btn flex flex-ac" @click="showMore=!showMore">{{ showMore?'收起':'展开' }}<i :class="[showMore?'el-icon-arrow-up':'el-icon-arrow-down']"></i></div>
          </div>
        </div>
      </div>
      <myhomebot></myhomebot>
    </div>
    <div class="commonBg"></div>
  </div>

</template>
<script>
import myhomebot from "@/components/my_homebot.vue";
import countdown from "@/g-components/countdown.vue";
import mySlide from "@/g-components/my_slide.vue";
import { parseColor } from "@/assets/js/util.js";

export default {
  components: { myhomebot, countdown, mySlide },
  data() {
    return {
      parseColor,
      activeName: "two",
      list: [],
      searchForm: {
        activeName: '',
        mode: 2,
        run_type: 1,
        type: 0,
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1
      },
      peopleObj: {
        id: 0,
        img: require("@/assets/img/jiapeople.png"),
        class: "pk-false",
        border: "1px dashed #e9b10e",
      },
      boxInfo: {
        name: '',
        content: ''
      },
      showMore: false
    };
  },
  created() {
    let data = sessionStorage.getItem('fightF')
    if (data) {
      let temp = JSON.parse(data)
      this.activeName = temp.activeName
      this.searchForm = temp
    }
    this.getData()
    this.getList()
    this.initWebSocket()
  },
  beforeDestroy() {
    this.searchForm.activeName = this.activeName
    sessionStorage.setItem('fightF', JSON.stringify(this.searchForm))
    this.websock.onclose = null
    this.websock.close()
  },
  methods: {
    getData() {
      this.$doGet("/api/setting.Accord/info", {
        accord_id: 'BoxBattle'
      }).then((res) => {
        this.boxInfo = res.data
      }).catch(() => { })
    },
    //点击挑战房间
    goLuckyRoom(item, id) {
      console.log(item)
      if (item.status == 1) {
        if (!this.$store.state.loginState) {
          this.$store.commit("getLogin", true);
          return;
        } else {
          this.$router.push({
            path: `/fight/room`,
            query: {
              id: id,
            },
          });
        }
      } else {
        this.$router.push({
          path: `/fight/room`,
          query: {
            id: id,
          },
        });
      }
    },
    handleCommand(e) {
      if (this.searchForm.type == e) {
        this.searchForm.type = 0
      } else {
        this.searchForm.type = e
      }
      this.searchForm.page = 1
      this.getList()
    },

    handleClick(e) {
      if (e == this.activeName) {
        return false
      }
      this.searchForm.type = 0
      this.searchForm.mode = ''
      this.searchForm.run_type = ''
      if (e == 'two') {
        this.searchForm.mode = 2
        this.searchForm.run_type = 1
      }
      if (e == 'three') {
        this.searchForm.mode = 3
        this.searchForm.run_type = 1
      }
      if (e == 'history') {
        this.searchForm.run_type = 2
      }
      this.list = []
      this.activeName = e
      this.searchForm.page = 1
      this.getList();
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    },
    //对战列表
    getList() {
      this.$doGet(this.activeName == 'me' ? '/api/hall.Battle/myHistoryList' : "/api/hall.Battle/list", this.searchForm).then((res) => {
        this.list = []
        res.data.list.map(item => {
          item.fightboxList = []
          item.boxInfo.forEach(bitem => {
            for (let i = 0; i < bitem.num; i++) {
              item.fightboxList.push(bitem)
            }
          })
          if (item.mode > item.player_info.length) {
            let temp = item.mode - item.player_info.length
            for (let i = 0; i < temp; i++) {
              item.player_info.push(this.peopleObj)
            }
          }
          this.list.push(item)
        })
        this.searchForm.pages = res.data.pages
        this.searchForm.totalSize = res.data.count
      }).catch(() => { })
    },
    // 结束
    updateBattleList(item) {
      if (item.mode > item.player_info.length) {
        item.fightboxList = []
        item.boxInfo.forEach(bitem => {
          for (let i = 0; i < bitem.num; i++) {
            item.fightboxList.push(bitem)
          }
        })
        let temp = item.mode - item.player_info.length
        for (let i = 0; i < temp; i++) {
          item.player_info.push(this.peopleObj)
        }
      }
      this.list.forEach((ele, index) => {
        if (ele.id == item.id) {
          this.$set(this.list, index, item)
        }
      })
    },
    addBattleList(item) {
      if (item.mode > item.player_info.length) {
        let temp = item.mode - item.player_info.length
        for (let i = 0; i < temp; i++) {
          item.player_info.push(this.peopleObj)
        }
      }
      let ids = this.list.map(v => v.id)
      if (ids.indexOf(item.id) == -1) {
        this.list.push(item)
      }
      this.awaitRoom = 0;
      this.list.map(item => {
        if (item.status == "1") {
          this.awaitRoom = this.awaitRoom + 1;
        }
      })
    },
    sockBattleList(d) {
      console.log('接收数据：', d)
      let data = JSON.parse(d);
      console.log('处理后数据：', data)
      if (data.mode == 'battle') {
        if (data.state == "update") {
          this.updateBattleList(data.info);
        }
        // else if (data.state == "add") {
        //   this.addBattleList(data.info);
        // }
      }
      //排序
    },
    //推送
    initWebSocket() {
      const domains = window.location.host.split('.')
      const wsuri = process.env.VUE_APP_WEBSOCKET == '' ? ('wss://api.' + domains[domains.length - 2] + '.' + domains[domains.length - 1] + '/ws') : process.env.VUE_APP_WEBSOCKET
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //let actions = { test: "12345" };
      //this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {
      this.initWebSocket();
    },
    websocketonmessage(d) {
      this.sockBattleList(d.data);
    },
    websocketsend(Data) {
      if (this.websock.readyState === WebSocket.OPEN) {
        this.websock.send(Data);
      }
    },
    websocketclose(e) {
      // console.log("close:", e);
    },
  }
};
</script>

<style lang="less" scoped>
.fight {
  min-height: 100vh;
  .fight-warp {
    // padding-top: 40px;
    .room-box {
      padding: 20px 0;
      flex-grow: 3;
      flex-basis: 0;
      .room-box-ul {
        margin-top: -8px;
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        li {
          height: 187px;
          cursor: pointer;
          overflow: hidden;
          .roombox-warp {
            border-radius: 5px;
            .no {
              padding: 10px 15px 0;
              color: #fff;
              font-size: 14px;
            }
            .one {
              height: 40px;
              padding: 0 15px;
              .span1 {
                color: #999;
                font-size: 14px;
                display: flex;
                align-items: center;
                .span-dian {
                  width: 8px;
                  height: 8px;
                  display: inline-block;
                  margin-right: 10px;
                  border-radius: 4px;
                  background-color: #999;
                }
              }
              .status-img {
                height: 17px;
              }
              .span3 {
                color: #c3c3e2;
                font-size: 14px;
              }
            }
            .two {
              margin: 15px 0 5px;
              .room-peo {
                .pk-warp {
                  .pk-true {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                  }
                  .pk-false {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    padding: 5px;
                    border: 1px dashed #e9b10e;
                  }
                  .pk-vs {
                    width: 17px;
                    height: 12px;
                    margin: 0 10px;
                  }
                }
              }
            }
            .card-footer {
              padding: 0 15px;
              .two-top {
                font-size: 16px;
                color: #e9b10e;
                img {
                  height: 18px;
                  margin-right: 5px;
                }
              }
            }
            .three {
              display: flex;
              flex-wrap: nowrap;
              overflow-x: auto;
              .box-detail {
                position: relative;
                margin-right: 5px;
                img {
                  height: 40px;
                  width: auto;
                  border-radius: 50%;
                }
                .box-num {
                  position: absolute;
                  top: 0;
                  right: -5px;
                  width: 15px;
                  text-align: center;
                  line-height: 15px;
                  border-radius: 50%;
                  background-color: #e9b10e;
                  color: #000;
                  font-size: 12px;
                }
              }
            }
            .three::-webkit-scrollbar {
              /*滚动条整体样式*/
              width: 10px;
              /*高宽分别对应横竖滚动条的尺寸*/
              height: 6px;
            }

            .three::-webkit-scrollbar-thumb {
              /*滚动条里面小方块*/
              border-radius: 10px;
              background-color: #4b575c;
            }

            .three::-webkit-scrollbar-track {
              /*滚动条里面轨道*/
              box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
              // background: #243438;
            }
          }
          &.bg_1 {
            background-image: url(~@/assets/img/fight/await.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .roombox-warp {
              .one {
                .span1 {
                  color: #d8372b;
                  .span-dian {
                    background-color: #d8372b;
                  }
                }
                .span3 {
                  color: #d8372b;
                }
              }
            }
          }
          &.bg_2 {
            background-image: url(~@/assets/img/fight/going.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .roombox-warp {
              .one {
                .span1 {
                  color: #e9b10e;
                  .span-dian {
                    background-color: #e9b10e;
                  }
                }
                .span3 {
                  color: #e9b10e;
                }
              }
            }
            // background-image: ;
          }
          &.bg_3 {
            background-image: url(~@/assets/img/fight/end.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            opacity: 0.5;
          }
        }
      }
    }
    .btn-w-r-bg {
      width: 200px;
      margin: 20px auto;
    }
  }
  .about {
    background-color: #181c1f;
    box-sizing: border-box;
    padding-top: 30px;
    .info {
      box-sizing: border-box;
      border-radius: 8px;
      border: 2px solid #1c3c4d;
      margin: 32px auto 0;
      color: #fff;
      line-height: 26px;
      padding: 30px;
      .height40 {
        max-height: 400px;
      }
      .show-btn {
        padding: 30px 0 0;
        cursor: pointer;
      }
    }
  }
  .no-data {
    padding: 100px 0;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    img {
      width: 182px;
      margin-bottom: 10px;
    }
  }
}
.fight-search {
  // padding-top: 15px;
  .fight-search-top {
    height: 60px;
    position: relative;
    padding: 15px 0;
    .scRadio {
      z-index: 2;
      position: absolute;
      left: 50%;
      top: calc(50% - 18px);
      transform: translateX(-50%); /* 关键：真正居中 */
      // position: absolute;
      // left: calc(50% - 135px);
    }
  }
  .fight-search-form {
    background: #1e1a17;
    padding: 15px;
    border-radius: 8px;
    color: #fff;
    font-size: 17px;
    .s-item {
      padding-left: 20px;
      cursor: pointer;
      &.s-item-active {
        color: #e9b10e;
      }
      span {
        margin-left: 6px;
      }
    }
  }
}
.sel-form-select {
  ::v-deep .el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #6a6a6a;
    border: 1px solid #6a6a6a;
    background-color: transparent;
  }
  ::v-deep .el-input__icon {
    line-height: 30px;
  }
}
.sel-form-select {
  width: 90px;
  margin-left: 10px;
  vertical-align: middle;
  ::v-deep .el-input__inner {
    padding: 0 10px;
  }
}
</style>
